import Vue from "vue";
import VueRouter from "vue-router";
import jsCookie from "js-cookie";
import Home from "../views/home/index.vue";
import CoreCompetence from "../views/CoreCompetence/index.vue";
import Solution from "../views/Solution/index.vue";
import ProductService from "../views/ProductService/index.vue";
import Byjsfwq from "../views/ProductService/components/byjsfwq.vue";
import Bjznfxh from "../views/ProductService/components/bjznfxh.vue";
import Zhsqglpt from "../views/ProductService/components/zhsqglpt.vue";
import Sqfwpt from "../views/ProductService/components/sqfwpt.vue";
import Jczlpt from "../views/ProductService/components/jczlpt.vue";
import Wgzxxcx from "../views/ProductService/components/wgzxxcx.vue";
import Wp from "../views/ProductService/components/wp.vue";
import NewsCenter from "../views/NewsCenter/index.vue";
import NewsInfo from "../views/NewsCenter/components/newsInfo.vue";
import AboutUs from "../views/AboutUs/index.vue";
import JoinUs from "../views/JoinUs/index.vue";
import Aiot from "../views/ProductService/components/aiot.vue";
import Dsjpt from "../views/ProductService/components/dsjpt.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/core-competence",
    name: "coreCompetence",
    component: CoreCompetence
  },
  {
    path: "/solution",
    name: "solution",
    component: Solution
  },
  {
    path: "/product-service",
    name: "productService",
    component: ProductService
  },
  {
    path: "/byjsfwq",
    name: "byjsfwq",
    component: Byjsfwq
  },
  {
    path: "/bjznfxh",
    name: "bjznfxh",
    component: Bjznfxh
  },
  {
    path: "/zhsqglpt",
    name: "zhsqglpt",
    component: Zhsqglpt
  },
  {
    path: "/jczlpt",
    name: "jczlpt",
    component: Jczlpt
  },
  {
    path: "/sqfwpt",
    name: "sqfwpt",
    component: Sqfwpt
  },
  {
    path: "/wp",
    name: "wp",
    component: Wp
  },
  {
    path: "/wgzxxcx",
    name: "wgzxxcx",
    component: Wgzxxcx
  },
  {
    path: "/news-center",
    name: "newsCenter",
    component: NewsCenter
  },
  {
    path: "/news-info",
    name: "newsInfo",
    component: NewsInfo
  },
  {
    path: "/about-us",
    name: "aboutUs",
    component: AboutUs
  },
  {
    path: "/join-us",
    name: "joinUs",
    component: JoinUs
  },
  {
    path: "*",
    redirect: "/"
  },
  {
    path: "/aiot",
    name: "aiot",
    component: Aiot
  },
  {
    path: "/dsjpt",
    name: "dsjpt",
    component: Dsjpt
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        // 通过 to.hash 的值來找到对应的元素
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!jsCookie.get("token")) {
      next({
        path: "/",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // 确保一定要调用 next()
  }
});
export default router;
